// @flow
import * as React from 'react'
import styled from 'styled-components'
import ReactSelect from 'react-select'
import AsyncSelect from 'react-select/lib/Async'
import FormField from '../FormField/index'
import { find, map } from 'lodash/fp'
import ErrorMessage from '../ErrorMessage'
import componentStyles from './styles'
import CustomClearIndicator from "./CustomClearIndicator"
import CustomMultiValueRemove from "./CustomMultiValueRemove"

const Select = ({
  options,
  label,
  width,
  margin,
  marginTop,
  input: { value, onChange, name },
  placeholder = 'Wybierz',
  menuPlacement = 'auto',
  errorMessages = {},
  disableValidation = false,
  disabled = false,
  isMulti = false,
  isAsync = false,
  fieldWidth,
  reference,
  ...props
}) => {
  return (
    <RelativeDiv>
      <StyledFormField
        label={label}
        labelFor={name}
        fieldWidth={fieldWidth}
        marginTop={marginTop}
      >
        <SelectWrapper $width={width} margin={margin}>
          {isAsync ? (
            <AsyncSelect
              inputId={name}
              aria-label
              ref={reference}
              isMulti={isMulti}
              value={
                isMulti
                  ? map((val) => find({ value: val }, options), value)
                  : find({ value }, options) || null
              }
              // eslint-disable-next-line no-shadow
              onChange={(option) => {
                if (!option) return onChange(null)
                else if (isMulti) return onChange(map('value', option))
                return onChange(option['value'])
              }}
              cacheOptions
              placeholder={placeholder}
              styles={componentStyles}
              isDisabled={disabled}
              menuPlacement={menuPlacement}
              components={{ ClearIndicator: CustomClearIndicator, MultiValueRemove: CustomMultiValueRemove }}
              {...props}
            />
          ) : (
            <ReactSelect
              inputId={name}
              aria-label
              ref={reference}
              isMulti={isMulti}
              value={
                isMulti
                  ? map((val) => find({ value: val }, options), value)
                  : find({ value }, options) || null
              }
              // eslint-disable-next-line no-shadow
              onChange={(option) => {
                if (!option) return onChange(null)
                else if (isMulti) return onChange(map('value', option))
                return onChange(option['value'])
              }}
              options={options}
              placeholder={placeholder}
              styles={componentStyles}
              isDisabled={disabled}
              menuPlacement={menuPlacement}
              components={{ ClearIndicator: CustomClearIndicator, MultiValueRemove: CustomMultiValueRemove }}
              {...props}
            />
          )}
        </SelectWrapper>
      </StyledFormField>
      {(props.meta.error || props.meta.submitError) &&
        props.meta.touched &&
        !disableValidation && (
          <ErrorMessage
            marginTop
            errorMessages={errorMessages}
            error={props.meta.error || props.meta.submitError}
          />
        )}
    </RelativeDiv>
  )
}

const RelativeDiv = styled.div`
  display: flex;
`

const StyledFormField = styled(FormField)`
  ${(props) => (props.marginTop ? 'margin-top: -25px' : 'margin-top: -30px')};
  margin-bottom: 16px;
  ${(props) => props.fieldWidth && `width:${props.fieldWidth}`}
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin-bottom: 30px;
  margin-top: 6px;
  ${(props) => props.margin && `margin: ${props.margin}px`};
  ${(props) => props.$width && `width: ${props.$width}px`};
`

export default Select
